import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { FormField, StaticField as StaticFieldType } from '~/types/SSOForm';

type Props = {
  formField: FormField<StaticFieldType>;
  onExplain?: (fieldId: string) => void;
};

export const StaticField = ({ formField, onExplain }: Props) => {
  const intl = useIntl();

  return (
    <Layout direction="column" spacing={2}>
      <Layout direction="column">
        <Layout spacing="1">
          <Text variant="body-medium">{formField.title}</Text>
          {!formField.required && (
            <Text variant="tiny" color="text.secondary">
              {intl.formatMessage({
                id: 'StaticField.optionalLabel',
                defaultMessage: '(optional)',
                description: 'Label indicating field is optional',
              })}
            </Text>
          )}
          {onExplain && (
            <Button
              text={intl.formatMessage({
                id: 'StaticField.explainButton',
                defaultMessage: 'Explain this',
                description: 'Button text to explain the field',
              })}
              variant="action"
              onClick={() => onExplain(formField.fieldName)}
            />
          )}
        </Layout>
        <Text color="text.secondary">{formField.description}</Text>
      </Layout>

      {formField.field.value.map((staticField, index) => (
        <Layout direction="column" key={`static_field_${index}`}>
          <Text variant="tiny" color="text.secondary">
            {staticField.title}
          </Text>
          <Text variant="body-medium">{staticField.value}</Text>
        </Layout>
      ))}
    </Layout>
  );
};
